import React from "react";
import { COLORS } from "../constants/colors";
import Seo from "../components/Seo";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  // const lastUpdated = new Date().toDateString();
  const lastUpdated = "22 December 2025";


  return (
    <div className="policy-container">
      <Seo title="Privacy Policy — BudgetMate" description="Privacy policy for BudgetMate — how we collect and use data." />
      <section className="policy-header">
        <h1 style={{ color: COLORS.primary }}>Privacy Policy</h1>
        <p className="updated">
          <strong>Last updated:</strong> {lastUpdated}
        </p>
      </section>

      <section className="policy-content">
        <p>
          BudgetMate ("we", "our", "us") is a smart expense tracking application.
          Your privacy is very important to us. This Privacy Policy explains how
          we collect, use, and protect your information.
        </p>

        <h2>Information We Collect</h2>
        <ul>
          <li>Email address for account authentication</li>
          <li>User-provided expense and income data</li>
          <li>Basic device information for app performance and security</li>
        </ul>

        <h2>How We Use Your Information</h2>
        <ul>
          <li>To authenticate users securely</li>
          <li>To store and manage expense data</li>
          <li>To improve app features and user experience</li>
        </ul>

        <h2>Data Security</h2>
        <p>
          We use industry-standard security practices to protect your data. Your
          personal information is never sold or shared with third parties.
        </p>

        <h2>Third-Party Services</h2>
        <p>
          BudgetMate may use trusted third-party services (such as cloud services
          or payment gateways) strictly to support app functionality. These
          services will only receive data necessary to perform their function and
          operate under their own privacy policies.
        </p>

        <h2>User Rights</h2>
        <p>
          You can request data deletion or account removal at any time by
          contacting us.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Changes will be
          reflected on this page and the "Last updated" date will be revised when
          material changes occur.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at:
          <br />
          <strong>Email:</strong>{" "}
          <a href="mailto:budgetmate1.app@zohomail.in">
            budgetmate1.app@zohomail.in
          </a>
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
